import config from '../config';
import { ActionTypes as actions, UserActions, ConsultationsActions, ToastActions } from '../actions';
import { History as history, Routes as routes } from '../navigation';
import axios from 'axios';

const createInstantAccount = (user_data, callback) => {
  return dispatch => {

    let requestURL = `${config.BASE_URL}/register_with_verify`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } }

    axios.post(requestURL, JSON.stringify(user_data), requestConfig).then((response) => {
      let data = response.data || {};
      let user = data.data || null;

      if (data.success) {
        let email    = user_data.email;
        let password = user_data.password;
        dispatch(instantLogin(email, password));
      } else {
        let error_message = data && data.message ? data.message : '';
        dispatch(ToastActions.displayError(error_message));
      }

      callback();
    }).catch((error) => {
      callback();
      dispatch(ToastActions.displayError('Registration Error'));
    });

  }
}

const instantLogin = (email, password, code, callback) => {
  return dispatch => {

    let requestURL    = `${config.BASE_URL}/login`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } }
    let login_info    = { email: email, password: password, code: code };

    axios.post(requestURL, JSON.stringify(login_info), requestConfig).then((response) => {
      let data = response.data || {};

      if (data.success) {
        let token   = data.token;
        let user_id = data.user_id;
        dispatch(getInsantUserInfo(token, user_id))
        dispatch({ type: actions.INSTANT_UPDATE_DISPLAY_VALIDATION, payload: {} });
      } else {
        let display_invalid = data.validity && data.validity === 'invalid' ? true : false;
        if (display_invalid) {
          dispatch({ type: actions.INSTANT_UPDATE_DISPLAY_VALIDATION, payload: { em: email, pw: password, displayValidation: true } });
          history.replace(routes.INSTANT_VALIDATION);
        }
        let error_message = data && data.message ? data.message : '';
            error_message = data && data.error && data.error.message ? data.error.message : error_message;
        dispatch(ToastActions.displayError(error_message));
      }

      if (callback) {
        callback()
      }
    }).catch((error) => {
      if (callback) {
        callback()
      }
      dispatch(ToastActions.displayError('Login Error'));
    });

  }
}

const getInsantUserInfo = (token, user_id) => {

  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/user`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const user = data.data;

      if (user && user.is_instant) {
        dispatch(UserActions.authenticationSuccess(token, user_id));
        dispatch(getInstantUserRoles(token, user_id));
        dispatch({ type: actions.USER_UPDATE_INFO, payload: user });
        history.replace(routes.INSTANT_HOME);
      } else if (user && user.type === 'PROVIDER' && !user.is_instant) {
        dispatch(ToastActions.displayError("Looks like you have a TeleTails account already! Please reach out to the team or to rosie@teletails.com and we'll get you set up personally."));
      } else {
        dispatch(ToastActions.displayError('The Web Portal is accessible to TeleTails Instant accounts only.'));
      }
    }).catch((error) => { console.log(error) });

  }
}

const getInstantUserRoles = (token, user_id) => {
  return dispatch => {

    const requestURL = `${config.BASE_URL}/api/user/user_roles/${user_id}`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const roles = data.roles || [];

      if (data.success && roles && roles.length > 0) {
        let role        = roles[0];
        let practice_id = role && role.practice_id ? role.practice_id : '';
        dispatch(getInstantPracticeInfo(token, practice_id));
      }

    }).catch((error) => { console.log(error) })

  }
}

const getInstantPracticeInfo = (token, practice_id) => {
  return dispatch => {

    let practice_info_url     = `${config.BASE_URL}/api/practice/${practice_id}`;
    let pracitce_location_url = `${config.BASE_URL}/api/practice/location/${practice_id}`;
    let request_configs       =  { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    let practice_info_promise = axios.get(practice_info_url, request_configs);
    let practice_loc_promise  = axios.get(pracitce_location_url, request_configs);

    let results = Promise.all([practice_info_promise, practice_loc_promise]).then((res) => {
      let practice_info      = res && res[0] && res[0].data && res[0].data.data ? res[0].data.data : {};
      let practice_locations = res && res[1] && res[1].data && res[1].data.locations ? res[1].data.locations : [];
      let practice_location  = practice_locations && practice_locations[0] ? practice_locations[0] : {};

      dispatch({ type: actions.INSTANT_PRACTICE_UPDATE, payload: practice_info     });
      dispatch({ type: actions.INSTANT_LOCATION_UPDATE, payload: practice_location });
    })
  }
}

const sendInstantInvite = (token, invite_data, callback) => {
  return dispatch => {

    let requestURL    = `${config.BASE_URL}/api/instant/instant_session`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.post(requestURL, JSON.stringify(invite_data), requestConfig).then((response) => {
      let data = response.data || {};

      if (data.success) {
        dispatch(getNonCompletedSessions(token, invite_data.practice_id));
        dispatch(ToastActions.displayInfo('Invite Message Sent!'));
      } else {
        let error_message = data && data.message ? data.message : '';
            error_message = data && data.error && data.error.message  ? data.error.message : error_message;
            error_message = data && data.error && !data.error.message ? data.error : error_message;
        dispatch(getNonCompletedSessions(token, invite_data.practice_id));
        dispatch(ToastActions.displayError(error_message));
      }
      if (callback) {
        callback()
      }
    }).catch((error) => {
      if (callback) {
        callback();
      }
      dispatch(ToastActions.displayError('Error Creating Invite'));
    });

  }
}

const cancelSession = (token, practice_id, session_id, callback) => {
  return dispatch => {

    let requestURL    = `${config.BASE_URL}/api/instant/cancel_session/${practice_id}/${session_id}`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    let cancel_data   = { session_id: session_id };

    axios.post(requestURL, JSON.stringify(cancel_data), requestConfig).then((response) => {
      let data = response.data || {};
      let instant_session = data.instantSession;

      if (data.success) {
        dispatch(getNonCompletedSessions(token, practice_id));
        dispatch(ToastActions.displayInfo('Session Cancelled'));
        dispatch({ type: actions.INSTANT_DICT_UPDATE_ITEM, payload: instant_session });
      } else {
        dispatch(getNonCompletedSessions(token, practice_id));
        dispatch(ToastActions.displayError('Unable to cancel session'));
      }
      if (callback) { callback() }
    }).catch((error) => {
      if (callback) { callback() }
      dispatch(ToastActions.displayError('Error Cancelling Session'));
    });

  }
}

const completeSession = (token, practice_id, session_id, callback) => {
  return dispatch => {

    let requestURL    = `${config.BASE_URL}/api/instant/complete_session/${practice_id}/${session_id}`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    let complete_data = { session_id: session_id };

    axios.post(requestURL, JSON.stringify(complete_data), requestConfig).then((response) => {
      let data = response.data || {};
      let instant_session = data.instantSession;
      if (data.success) {
        dispatch(getNonCompletedSessions(token, practice_id));
        dispatch(ToastActions.displayInfo('Session Completed'));
        dispatch({ type: actions.INSTANT_DICT_UPDATE_ITEM, payload: instant_session });
      } else {
        dispatch(getNonCompletedSessions(token, practice_id));
        dispatch(ToastActions.displayError('Unable to complete session'));
      }
      if (callback) { callback() }
    }).catch((error) => {
      if (callback) { callback() }
      dispatch(ToastActions.displayError('Error Completing Session'));
    });

  }
}

const setJoinedOrLeftSession = (code, value) => {
  return dispatch => {

    let requestURL    = `${config.BASE_URL}/update_session/${code}/${value}`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } }
    let joined_data   = { code: code, is_set: value  }

    axios.post(requestURL, JSON.stringify(joined_data), requestConfig).then((response) => {
      let data = response.data || {};
    }).catch((error) => {  });

  }
}

const updateSession = (instantSession) => {
  return (dispatch, getState) => {

    let state        = getState();
    let all_sessions = state.instant && state.instant.instantSessions ? state.instant.instantSessions : {};

    if (all_sessions) {
      all_sessions[instantSession._id] = instantSession;
      dispatch({
        type: actions.INSTANT_DICT_UPDATE,
        payload: all_sessions,
      })

      dispatch(sortSessionDict());
    }

  }
}

const sortSessionDict = () => {
  return (dispatch, getState) => {

    let all_sessions  = dispatch(getCurrentSessionsDict());
    if (all_sessions) {
      var sorted_dict = {};
      var sessions    = Object.keys(all_sessions).map((session_id) => {
        return all_sessions[session_id];
      }).sort((a, b) => { return new Date(b.updated_at) - new Date(a.updated_at) });
      sessions.forEach((sesh) => {
        const sesh_status = sesh.status;
        if (sorted_dict[sesh_status]) {
          sorted_dict[sesh_status].push(sesh._id);
        } else {
          sorted_dict[sesh_status] = [sesh._id];
        }
      });

      dispatch({ type: actions.INSTANT_STATUS_DICT_UPDATE, payload: sorted_dict })
    }

  }
}

const getNonCompletedSessions = (token, practice_id) => {
  return dispatch => {

    let requestURL    = `${config.BASE_URL}/api/instant/instant_sessions/${practice_id}/["INVITED", "IN_PROGRESS"]`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};

      if (data.success) {
        let non_completed_sessions      = data.instantSessions || [];
        let invited_and_in_progress_ids = {};
        let sessions_dict               = dispatch(getCurrentSessionsDict());
        let updated_sesh_dict           = Object.assign({}, sessions_dict);

        invited_and_in_progress_ids['INVITED']     = [];
        invited_and_in_progress_ids['IN_PROGRESS'] = [];

        non_completed_sessions.forEach((session) => {
          updated_sesh_dict[session._id] = session;
          if (session.status === 'INVITED') {
            invited_and_in_progress_ids['INVITED'].push(session._id);
          }
          if (session.status === 'IN_PROGRESS') {
            invited_and_in_progress_ids['IN_PROGRESS'].push(session._id);
          }
        });

        dispatch({ type: actions.INSTANT_DICT_UPDATE,              payload: updated_sesh_dict });
        dispatch({ type: actions.INSTANT_UPDATE_NON_COMPLETED_IDS, payload: invited_and_in_progress_ids });
      }
    }).catch((error) => { console.log(error) })

  }
}

const getCompletedSessions = (token, practice_id) => {
  return (dispatch, getState) => {

    const requestURL = `${config.BASE_URL}/api/instant/instant_sessions/${practice_id}/["COMPLETED"]`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};

      if (data.success) {
        let existing_dict         = {};
        let completed_sessions    = data.instantSessions || [];
        let completed_session_ids = [];
        let completed_ids         = {};
        let sessions_dict         = dispatch(getCurrentSessionsDict());
        let updated_sesh_dict     = Object.assign({}, sessions_dict);

        completed_ids['COMPLETED'] = [];
        completed_ids['CANCELLED'] = [];

        completed_sessions.sort((a, b) => { return new Date(b.completed_at) - new Date(a.completed_at) });
        completed_sessions.forEach((session) => {
          updated_sesh_dict[session._id] = session;
          completed_session_ids.push(session._id)
          let was_cancelled = session && session.was_cancelled ? true : false;
          if (was_cancelled) {
            completed_ids['CANCELLED'].push(session._id);
          } else {
            completed_ids['COMPLETED'].push(session._id);
          }
        });

        dispatch({ type: actions.INSTANT_DICT_UPDATE,                    payload: updated_sesh_dict     });
        dispatch({ type: actions.INSTANT_UPDATE_COMPLETED_IDS,           payload: completed_session_ids });
        dispatch({ type: actions.INSTANT_COMPLETED_CANCELLED_IDS_UPDATE, payload: completed_ids         });
      }
    }).catch((error) => { console.log(error) })

  }
}

const getCurrentSessionsDict = () => {
  return (dispatch, getState) => {

    let state   = getState();
    let instant = state && state.instant ? state.instant : {};
    let dict    = instant && instant.instantSessions ? instant.instantSessions : {};

    return dict;

  }
}

const getVideoRooms = (token, session_id, callback) => {
  return dispatch => {

    let requestURL    = `${config.BASE_URL}/api/consultation/video/room/${session_id}`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      let data = response.data || {};
      let room = data.roomObject;
      let compositions = data.compositions || [];

      if (data.success) {
        let recording_data = {
          room: room,
          compositions: compositions,
        }
        callback(recording_data);
      }

    }).catch((error) => { console.log(error) })

  }
}

const startProcessingComposition = (token, session_id, callback) => {
  return dispatch => {

    let requestURL    = `${config.BASE_URL}/api/consultation/video/complete/${session_id}`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};

      if (data.success) {
        let rooms_arr = data && data.rooms        ? data.rooms : [];
        let comps_arr = data && data.compositions ? data.compositions : [];
        if (rooms_arr.length === 0 && comps_arr.length === 0) {
          dispatch(ToastActions.displayInfo('Video Recordings are not ready for processing yet. Please try again in a few minutes. It takes a few mintues after the conclusion of a session for the videos to be ready for processing.'));
        }
        callback(true);
      } else {
        callback(false);
        dispatch(ToastActions.displayError('No video data avaiable for this session'));
      }

    }).catch((error) => {
      callback(false);
      dispatch(ToastActions.displayError('Error retrieving data avaiable for this session'));
      console.log(error)
     })

  }
}

const getRoomVideoBuffer = (token, room_id, callback) => {
  return dispatch => {

    let requestURL    = `${config.BASE_URL}/api/consultation/video/get_video_buffer/${room_id}`;
    let requestConfig = { headers: { 'authorization': token }, responseType: "blob" }

    axios.get(requestURL, requestConfig).then((response) => {
      let data = response.data || {};

      if (data) {
        callback(data)
      }

    }).catch((error) => { console.log(error) })

  }
}

const updateInstantPageState = (new_state) => {
  return dispatch => {

    dispatch({ type: actions.INSTANT_UPDATE_PAGE_STATE, payload: new_state });

  }
}

const resendVerificationCode = (email) => {
  return dispatch => {

    let requestURL = `${config.BASE_URL}/resend_verification`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } }
    let data = { email: email }

    axios.post(requestURL, JSON.stringify(data), requestConfig).then((response) => {
      let data = response.data || {};

      if (data.success) {
        dispatch(ToastActions.displayInfo('Email Resent'));
      }

    }).catch((error) => {
      dispatch(ToastActions.displayError('Email Error'));
    });

  }
}

const openCompletedSessions = () => {
  return dispatch => {
    history.push(routes.INSTANT_COMPLETED);
  }
}

const openFaqScreen = () => {
  return dispatch => {
    history.push(routes.INSTANT_HELP);
  }
}

const populateTestData = () => {
  return dispatch => {

    let sample_session = {
      _id: '2',
      client_phone: '+15714841337',
      client_code: 'DKHFBS',
      provider_code: 'D9F8SD',
      client_name: 'Varun Karki',
      provider_name: 'Karthic Nevero',
      session_participant_count: 0,
      status: 'INVITED',
      type: 'INSTANT',
      instant_account_id: 'daslkdfjasdf9as8df',
      location_name: 'Chantilly',
      is_provider_connected: false,
      is_client_connected: false,
      completed_at: null,
      auto_completed: false,
      was_cancelled: false,
      created_at: new Date(),
      updated_at: new Date(),
    }

    let arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
    let sample_dict = {};
    let sample_sorted_dict = {};

    arr.forEach((item, i) => {
      let sesh = Object.assign({}, sample_session);
      sesh._id        = sesh._id + i;
      sesh.status     = i > 4  ? 'IN_PROGRESS' : sesh.status;
      sesh.status     = i > 10 ? 'COMPLETED'   : sesh.status;
      let sesh_status = sesh.status;
      sample_dict[sesh._id] = sesh;
      if (sample_sorted_dict[sesh_status]) {
        sample_sorted_dict[sesh_status].push(sesh);
      } else {
        sample_sorted_dict[sesh_status] = [sesh];
      }
    });

    dispatch({ type: actions.INSTANT_DICT_UPDATE,        payload: sample_dict        });
    dispatch({ type: actions.INSTANT_STATUS_DICT_UPDATE, payload: sample_sorted_dict });

  }
}

export default {
  cancelSession,
  completeSession,
  createInstantAccount,
  getRoomVideoBuffer,
  getCompletedSessions,
  getInstantPracticeInfo,
  getNonCompletedSessions,
  getVideoRooms,
  startProcessingComposition,
  instantLogin,
  setJoinedOrLeftSession,
  openCompletedSessions,
  openFaqScreen,
  populateTestData,
  resendVerificationCode,
  sendInstantInvite,
  updateInstantPageState,
  updateSession,
}
